export class SearchOperators {
  constructor(
    public orderBy: Array<OrderByField> = [],
    public limit: number = 10,
    public offset: number = 0,
  ) {}

  public addFieldToOrder(name: string, descending: boolean = false) {
    this.orderBy.push({
      fieldName: name,
      direction: descending
        ? OrderByFieldDirection.Descending
        : OrderByFieldDirection.Ascending,
    });
  }
  public clearFields() {
    this.orderBy = [];
  }
}

export type OrderByField = {
  fieldName: string;
  direction: OrderByFieldDirection;
};
enum OrderByFieldDirection {
  Descending = -1,
  Ascending = 1,
}
